// extracted by mini-css-extract-plugin
module.exports = {"text":"ExpandableList_text__2DLIU"};